<div (clickOutside)="onClickOutside()" class="dc-menu-button-container">
	<button
		(click)="toggleMenu()"
		[disabled]="actions()?.length === 0"
		[matTooltipDisabled]="actions().length === 0"
		[matTooltipPosition]="tooltipPosition$()"
		[matTooltip]="tooltip() | translate"
		[ngClass]="[sizeClass()]"
		class="dc-menu-button"
		type="button"
	>
		<span
			[class.open]="isOpen$()"
			[ngClass]="[buttonConfig()?.iconClass ? buttonConfig()?.iconClass : '', isOpen$() && buttonConfig()?.openClass ? buttonConfig()?.openClass : '']"
			class="dc-menu-button-icon"
		>
			@if (buttonConfig()?.icon !== 'TEMPLATE') {
				<i class="fad" [class]="buttonConfig()?.icon"></i>
			} @else {
				<ng-container *ngTemplateOutlet="buttonConfig()?.template"></ng-container>
			}
		</span>
	</button>

	@if (actions()?.length) {
		<div class="dc-menu-button-options" [class.hidden]="!isOpen$()" [ngClass]="[computedDirection$() ? computedDirection$() : '']">
			@for (button of actions$(); track button) {
				<button class="dc-menu-button-option" [ngClass]="[sizeClass()]" (click)="handleClick($event, button)" [matTooltip]="button?.label | translate" [matTooltipPosition]="tooltipPosition$()">
					<span class="dc-menu-button-option-icon" [ngClass]="[button.iconConfig?.iconClass ? button.iconConfig?.iconClass : '', button.iconConfig?.openClass ? button.iconConfig?.openClass : '']">
						@if (button.iconConfig?.icon !== 'TEMPLATE') {
							<i class="fad fa-lg" [class]="button.iconConfig.icon"></i>
						} @else {
							<ng-container *ngTemplateOutlet="button.iconConfig.template"></ng-container>
						}
					</span>
				</button>
			}
		</div>
	}
</div>
